<template>
  <div
    class="loading-skeleton"
    :style="skeletonStyle"
    aria-busy="true"
    aria-hidden="true"
  />
</template>

<script>
export default {
  name: 'LoadingSkeletonRow',
  props: {
    width: {
      type: String,
      default: '75%'
    },
    possibleWidths: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '16px'
    },
    color: {
      type: String,
      default: '#e0e0e0'
    },
    borderRadius: {
      type: String,
      default: '4px'
    }
  },
  computed: {
    computedWidth() {
      if (!this.possibleWidths.length) {
        return this.width
      }
      const idx = Math.floor(Math.random() * this.possibleWidths.length)
      return this.possibleWidths[idx]
    },
    skeletonStyle() {
      return {
        width: this.computedWidth,
        height: this.height,
        backgroundColor: this.color,
        borderRadius: this.borderRadius
      }
    }
  }
}
</script>

<style scoped>
.loading-skeleton {
  animation: pulse 1.5s ease-in-out infinite;
  display: block;
  margin-bottom: 16px;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
